<div *ngIf="loading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div>
  <div class="flex flex-col gap-2.5 xl:flex-row">
    <div class="panel flex-1 px-0 py-6 ltr:xl:mr-6 rtl:xl:ml-6">
      <div class="mt-8 px-4">
        <form [formGroup]="form" (ngSubmit)="handleSave()">
          <div class="flex flex-col justify-between">
            <div class="w-full">
              <h1 class="mb-5 text-xl font-bold">
                {{ testemonialId ? ("testemonial.edit" | translate) : ("testemonial.create" | translate) }}
              </h1>

              <div [ngClass]="form.controls['title'].touched ? (form.controls['title'].errors ? 'has-error' : 'has-success') : ''" class="mt-4 flex flex-col sm:flex-row sm:items-center">
                <label for="title" class="mb-2 w-1/5 sm:mb-0 rtl:ml-2">{{ "blog.title" | translate }}</label>
                <div class="flex w-full flex-col sm:w-4/5">
                  <input id="title" type="text" formControlName="title" class="form-input w-full flex-1" [placeholder]="'blog.enter_title' | translate" />
                  <ng-container *ngIf="form.controls['title'].touched && form.controls['title'].errors">
                    <p class="mt-2 text-danger">
                      {{ "blog.please_provide_title" | translate }}
                    </p>
                  </ng-container>
                </div>
              </div>

              <div class="mt-4 flex flex-col sm:flex-row sm:items-center">
                <label for="category" class="mb-2 w-1/5 sm:mb-0 rtl:ml-2">{{ "blog.category" | translate }}</label>
                <app-picklist-select
                  #categorySelect
                  class="mb-0 w-full sm:w-1/3 rtl:ml-2"
                  id="category"
                  [type]="PicklistType.Testemonial"
                  labelForId="otherService"
                  [selectControl]="formSelectorCategory"
                  formControlName="id"
                  [searchable]="false"
                ></app-picklist-select>
                <button type="button" class="btn btn-outline-success ng-tns-c238-13 ng-star-inserted mt-2 flex sm:ml-6 sm:mt-0" (click)="addModal('testemonial')">+ {{ "blog.add_category" | translate }}</button>
              </div>
              <div class="mt-4 flex flex-col sm:flex-row sm:items-center">
                <label for="lan" class="mb-2 w-1/5 sm:mb-0 rtl:ml-2">
                  {{ "blog.language" | translate }}
                </label>
                <app-picklist-select
                  #lanSelect
                  class="mb-0 w-full sm:w-1/3 rtl:ml-2"
                  id="lan"
                  [type]="PicklistType.Language"
                  labelForId="otherService"
                  [selectControl]="formSelectorLanguage"
                  formControlName="id"
                  [searchable]="false"
                ></app-picklist-select>
                <button type="button" class="btn btn-outline-success ng-tns-c238-13 ng-star-inserted mt-2 flex sm:ml-6 sm:mt-0" (click)="addModal('language')">+ {{ "blog.add_language" | translate }}</button>
              </div>

              <div [ngClass]="form.controls['content'].touched ? (form.controls['content'].errors ? 'has-error' : 'has-success') : ''" class="mt-4 flex flex-col sm:flex-row sm:items-center">
                <label for="content" class="mb-2 w-1/5 sm:mb-0 rtl:ml-2">{{ "blog.content" | translate }}</label>
                <div class="flex w-full flex-col sm:w-4/5">
                  <quill-editor [modules]="modules1" formControlName="content" placeholder="" (onEditorCreated)="onEditorCreated($event)" class="w-full flex-1"></quill-editor>
                  <ng-container *ngIf="form.controls['content'].touched && form.controls['content'].errors">
                    <p class="mt-2 text-danger">
                      {{ "blog.please_provide_content" | translate }}
                    </p>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="mt-4 flex flex-col sm:flex-row sm:items-center">
              <label class="mb-2 w-full sm:mb-0 sm:w-1/5 rtl:ml-2" for="blog-images">{{ "testemonial.images" | translate }} </label>

              <div class="custom-file-container flex-1 lg:w-[250px]" data-upload-id="blog-images"></div>
            </div>

            <div class="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-1">
              <button *ngIf="!isLoading" type="submit" class="btn btn-success w-full gap-2">
                <icon-save class="shrink-0 ltr:mr-2 rtl:ml-2"></icon-save>
                {{ "blog.save" | translate }}
              </button>
              <button *ngIf="isLoading" type="button" class="btn btn-success w-full gap-2">
                <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>
                {{ "blog.loading" | translate }}
              </button>

              <button *ngIf="testemonialId" type="button" class="btn btn-danger w-full gap-2" (click)="handleDelete(testemonialId); handleRoute('blogs')">
                <icon-trash-lines class="shrink-0 ltr:mr-2 rtl:ml-2"></icon-trash-lines>
                {{ "blog.delete" | translate }}
              </button>
              <button type="button" class="btn btn-secondary w-full gap-2" (click)="handleRoute('testemonials')">
                <icon-arrow-backward class="shrink-0 ltr:mr-2 rtl:ml-2"></icon-arrow-backward>
                {{ "blog.back" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #addCategoryTemplate>
  <div class="flex flex-col p-4">
    <app-picklist-form [type]="selectedType" (notifyWhenSend)="categoryAdded($event)"></app-picklist-form>
  </div>
</ng-template>
